<template>
	<b-modal v-model="isShowPopup" dialog-class="modal-detail" @hidden="resetModal" scrollable :no-close-on-backdrop=true @ok="addButtonAction" title="Add Data Picking Supply For Production Detail">
		<b-card>
			<b-row>
				<b-col cols="12" lg="6">
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Material Part" id="input-" size="sm" :model.sync="model.materialPartId"   :selected="model.materialPart != null ? model.materialPart.partNumber : ''" @input="getParts" />
				<app-input-combobox-autocomplete :options="parts" optionsLabel="partNumber" optionsKey="id" label-cols-lg="12" label="Part" id="input-" size="sm" :model.sync="model.partId"   :selected="model.part != null ? model.part.partNumber : ''" @input="getParts" />
				<app-input-textbox id="fieldset-qty-supply" label-cols-lg="12" label="Qty Supply" label-for="input-qty-supply" size="sm" :model.sync="model.qtySupply"  />
				<app-input-textbox id="fieldset-qty-outstanding" label-cols-lg="12" label="Qty Outstanding" label-for="input-qty-outstanding" size="sm" :model.sync="model.qtyOutstanding"  />
					</b-col>
					<b-col cols="12" lg="6">
				<app-input-textarea id="fieldset-remark" label-cols-lg="12" label="Remark" label-for="input-remark" size="sm" :model.sync="model.remark"  />
				<app-input-combobox-autocomplete :options="documentStatuss" optionsLabel="name" optionsKey="id" label-cols-lg="12" label="DocumentStatus" id="input-" size="sm" :model.sync="model.documentStatusId"   :selected="model.documentStatus != null ? model.documentStatus.name : ''" @input="getDocumentStatuss" />
				<app-input-combobox-autocomplete :options="workOrderSupplyDetails" optionsLabel="materialPart" optionsKey="id" label-cols-lg="12" label="Work Order Supply Detail" id="input-" size="sm" :model.sync="model.workOrderSupplyDetailId"   :selected="model.workOrderSupplyDetail != null ? model.workOrderSupplyDetail.materialPart : ''" @input="getWorkOrderSupplyDetails" />

				</b-col>
			</b-row>
		</b-card>
		<b-overlay :show="isBusy" no-wrap></b-overlay>
		<template #modal-footer="{ ok, cancel }">
      		<slot name="modal-left-button"></slot>
			<b-button size="sm" class="btn-outline-danger float-right" @click="cancel()">
				Close
			</b-button>
      		<b-overlay
					:show="isBusy"
					rounded
					opacity="0.6"
					spinner-small
					spinner-variant="primary"
					class="float-right "
					>
      			<b-button size="sm" class="float-right btn-fill-success" @click="ok()">
				Save
			</b-button>
      		</b-overlay>
		</template>
	</b-modal>
</template>
<style lang="scss" scoped>
	::v-deep .modal-dialog {
		width: 70% !important; 
	}

	@media (max-width: 576px) {
		::v-deep .modal-dialog {
			width: calc(100%) !important;
		}
	}
</style>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import PickingSupplyForProductionDetail from '@/models/PickingSupplyForProduction/PickingSupplyForProductionDetail';
import PickingSupplyForProductionDetailFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionDetailFilter';

import PickingSupplyForProduction from '@/models/PickingSupplyForProduction/PickingSupplyForProduction';
import PickingSupplyForProductionFilter from '@/filters/PickingSupplyForProduction/PickingSupplyForProductionFilter';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import Part from '@/models/Part/Part';
import PartFilter from '@/filters/Part/PartFilter';
import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputTextarea from '@/components/AppInputTextarea';
import DocumentStatus from '@/models/DocumentStatus/DocumentStatus';
import DocumentStatusFilter from '@/filters/DocumentStatus/DocumentStatusFilter';
import WorkOrderSupplyDetail from '@/models/WorkOrderSupply/WorkOrderSupplyDetail';
import WorkOrderSupplyDetailFilter from '@/filters/WorkOrderSupply/WorkOrderSupplyDetailFilter';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	props: ['modelId', 'openPopup','addButtonMethod', 'resetMethod'],
	components : {
		AppInputComboboxAutocomplete,
		AppInputTextbox,
		AppInputTextarea,
		PopupRouterView,
	},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			model : {},
			errorMessage : {
			},
			parts : [],
			documentStatuss : [],
			workOrderSupplyDetails : [],
			isBusy: false,
		}
	},
	methods : {
		getPickingSupplyForProductionDetail : async function(id) {
			this.isBusy = true;
			PickingSupplyForProductionDetail.getData(this, id).then(result => {
				this.model = result;
				this.isBusy = false;
			}).catch(error => { this.isBusy = false; });
		},
		getParts : async function(input) {
			let filter = new PartFilter();
			if (input != undefined) {
				filter.partNumber = input;
			}
			Part.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.parts = result.data
				}
			})
			.catch(error => {});
		},
		getDocumentStatuss : async function(input) {
			let filter = new DocumentStatusFilter();
			if (input != undefined) {
				filter.name = input;
			}
			DocumentStatus.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.documentStatuss = result.data
				}
			})
			.catch(error => {});
		},
		getWorkOrderSupplyDetails : async function(input) {
			let filter = new WorkOrderSupplyDetailFilter();
			if (input != undefined) {
				filter.materialPart = input;
			}
			WorkOrderSupplyDetail.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.workOrderSupplyDetails = result.data
				}
			})
			.catch(error => {});
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		addButtonAction(modalEvent) {
			modalEvent.preventDefault();

			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				let model = this.model;
				let promises = Array();
				let _this = this;
					

					
				Promise.all(promises).then((results) => {
					_this.$emit("addButtonMethod", modalEvent, _this.model); 
				});

				this.$nextTick(() => { this.$v.$reset() })
			}
		},
		resetModal() {
			this.$emit('resetMethod');
			this.$v.$reset();
		},

	},	beforeMount() {
		//this.getParts();
		//this.getDocumentStatuss();
		//this.getWorkOrderSupplyDetails();
	},
	async mounted(){
	},
	watch : {
		modelId(newValue) {
			if (newValue != null && newValue != undefined && newValue != '') {
				this.getPickingSupplyForProductionDetail(newValue);
			} else {
				this.model = {};
			}
		},
		openPopup(newValue) {
			if (newValue) {
				this.getParts();
				this.getDocumentStatuss();
				this.getWorkOrderSupplyDetails();
				if (this.modelId != null && this.modelId != undefined && this.modelId != '') {
					this.getPickingSupplyForProductionDetail(this.modelId);
				}
			} else {
				this.model = {};
			}
		}
	},
	computed: {
		isShowPopup : {
			get: function () {
				if (this.openPopup) return true;
				else return false;
			},
			set: function (newValue) {}
		},
	}
}
</script>
